// utils.js - Utility functions (Fixed version)
import React from 'react';
import { styles } from './styles';
import { AlertTriangle, CheckCircle, Activity } from 'lucide-react';

export const utils = {
    // Format timestamp
    formatTimestamp: (timestamp) => {
        if (!timestamp) return 'N/A';
        return new Date(timestamp).toLocaleString();
    },

    // Get status color based on message
    getStatusColor: (message) => {
        if (!message) return styles.statusBlue;
        if (message.toLowerCase().includes('failed') || message.toLowerCase().includes('error')) {
            return styles.statusRed;
        } else if (message.toLowerCase().includes('success') || message.toLowerCase().includes('granted')) {
            return styles.statusGreen;
        }
        return styles.statusBlue;
    },

    // Get status icon based on message
    getStatusIcon: (message) => {
        if (!message) return React.createElement(Activity, { size: 16, style: { color: '#60a5fa' } });
        if (message.toLowerCase().includes('failed') || message.toLowerCase().includes('error')) {
            return React.createElement(AlertTriangle, { size: 16, style: { color: '#f87171' } });
        } else if (message.toLowerCase().includes('success') || message.toLowerCase().includes('granted')) {
            return React.createElement(CheckCircle, { size: 16, style: { color: '#4ade80' } });
        }
        return React.createElement(Activity, { size: 16, style: { color: '#60a5fa' } });
    },

    // Get connection status style
    getConnectionStatusStyle: (connectionStatus) => {
        switch (connectionStatus) {
            case 'connected':
                return { ...styles.statusBadge, ...styles.statusConnected };
            case 'disconnected':
                return { ...styles.statusBadge, ...styles.statusDisconnected };
            default:
                return { ...styles.statusBadge, ...styles.statusChecking };
        }
    },

    // Get status dot color
    getStatusDotColor: (connectionStatus) => {
        switch (connectionStatus) {
            case 'connected':
                return '#10b981';
            case 'disconnected':
                return '#ef4444';
            default:
                return '#f59e0b';
        }
    },

    // Export data to CSV
    exportToCSV: (filteredData) => {
        const headers = ['ID', 'Timestamp', 'Origin', 'Destination', 'Message'];
        const csvContent = [
            headers.join(','),
            ...filteredData.map(row => [
                row.id || 'N/A',
                row.timestamp || 'N/A',
                `"${row.access_origin || 'N/A'}"`,
                `"${row.access_destination || 'N/A'}"`,
                `"${row.message || 'N/A'}"`
            ].join(','))
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `access_data_${new Date().toISOString().split('T')[0]}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
    },

    // Filter data with multi-column search
    filterData: (accessData, searchTerm, originFilter, countryFilter) => {
        return accessData.filter(item => {
            const matchesSearch = !searchTerm ||
                item.access_origin?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.message?.toLowerCase().includes(searchTerm.toLowerCase());

            const matchesOrigin = originFilter === 'All Origins' || item.access_origin === originFilter;
            const matchesCountry = countryFilter === 'All Countries' || item.access_destination === countryFilter;

            return matchesSearch && matchesOrigin && matchesCountry;
        });
    },

    // Check if filters are active
    hasActiveFilters: (searchTerm, originFilter, countryFilter) => {
        return searchTerm || originFilter !== 'All Origins' || countryFilter !== 'All Countries';
    }
};